// givingBannerStreamSettings.js

const state = {
  givingBannerStreamSettings: {}, // Holds the giving banner streaming settings
  givingBannerPollingIntervalId: null, // Stores interval ID
  givingBannerPollingIntervalTime: 10000, // 10 seconds polling
}

const mutations = {
  SET_GIVING_BANNER_STREAM_SETTINGS(state, payload) {
    state.givingBannerStreamSettings = payload
  },
  SET_GIVING_BANNER_POLLING_INTERVAL_ID(state, intervalId) {
    state.givingBannerPollingIntervalId = intervalId
  },
}

const actions = {
  async fetchGivingBannerStreamSettings({ commit }) {
    if (!window.base_domain || !window.Church || !window.Church.slug) {
      return
    }

    try {
      const response = await fetch(`//api.${window.base_domain}/${window.Church.slug}/giving-banner-streaming-settings`)
      if (response.status === 200) {
        const finalRes = await response.json()
        commit('SET_GIVING_BANNER_STREAM_SETTINGS', finalRes.data)
      } else {
        console.error('Failed to fetch giving banner stream settings, status: ' + response.status)
      }
    } catch (error) {
      // Network errors (CORS, DNS, connectivity) are expected in some embed contexts
      console.error('Error fetching giving banner stream settings:', error.message)
    }
  },
  startGivingBannerPolling({ dispatch, state, commit }) {
    dispatch('fetchGivingBannerStreamSettings')

    if (state.givingBannerPollingIntervalId) {
      clearInterval(state.givingBannerPollingIntervalId)
    }

    const intervalId = setInterval(() => {
      dispatch('fetchGivingBannerStreamSettings')
    }, state.givingBannerPollingIntervalTime)

    commit('SET_GIVING_BANNER_POLLING_INTERVAL_ID', intervalId)
  },
  stopGivingBannerPolling({ state, commit }) {
    if (state.givingBannerPollingIntervalId) {
      clearInterval(state.givingBannerPollingIntervalId)
      commit('SET_GIVING_BANNER_POLLING_INTERVAL_ID', null)
    }
  },
}

const getters = {
  givingBannerStreamSettings(state) {
    return state.givingBannerStreamSettings
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
